import { Component, OnInit } from "@angular/core";
import * as _ from 'lodash';
import { PipedTableColumn } from "../custom-table-column/piped-table-column";
import { CustomTableValueComponent } from "./abstract-custom-table-value.component";

@Component({
    selector: 'piped-table-value',
    template: '<span [ngClass]="getClass()" [innerHTML]="column.localizationEnabled ? (getValue() | loader:column.pipe:false:pipeArgument | localize) : (getValue() | loader:column.pipe:false:pipeArgument)" (click)="goToDetailsWithPath($event)"></span>'
})
export class PipedTableValueComponent extends CustomTableValueComponent<PipedTableColumn> implements OnInit {
    pipeArgument: any;

    ngOnInit(): void {
        let pipeArgumentValue;
        let elementObject = {};
        if (this.column?.isArgumentPath) {
            pipeArgumentValue = _.get(this.element, this.column.pipeArgument, null);
        } else {
            pipeArgumentValue = this.column.pipeArgument;
        }
        if (this.column.pipeArgumentResolver) {
            pipeArgumentValue = this.column.pipeArgumentResolver(pipeArgumentValue, this.element);
        }
        if (this.column.pipeArgumentObjectName) {
            elementObject[this.column.pipeArgumentObjectName] = this.element;
            this.pipeArgument = Object.assign({}, pipeArgumentValue, elementObject);
        } else {
            this.pipeArgument = pipeArgumentValue;
        }
    }
}